module.exports = __webpack_public_path__ + "img/test_after_ai.07271bb7.jpg";